export enum ReaggregationType {
  Product = 1,
  Acquisition = 2
}
